import { apiClient } from './api-client';

export interface ModelAccessoryItem {
  id: string;
  name: string;
  description: string | null;
  isActive: boolean;
}

export interface ModelServiceTaskItem {
  id: string;
  code: string;
  name: string;
  description: string | null;
  isActive: boolean;
}

export interface EquipmentModel {
  id: string;
  tenantId: string;
  manufacturerId: string;
  manufacturerName: string;
  equipmentTypeId: string;
  equipmentTypeName: string;
  modelNumber: string;
  name: string | null;
  description: string | null;
  isActive: boolean;
  imageUrls: string[];
  accessories: ModelAccessoryItem[];
  serviceTasks: ModelServiceTaskItem[];
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface EquipmentModelListResponse {
  items: EquipmentModel[];
  page: number;
  pageSize: number;
  total: number;
}

export interface CreateEquipmentModelPayload {
  modelNumber: string;
  manufacturerId: string;
  equipmentTypeId: string;
  name?: string;
  description?: string;
  accessoryIds?: string[];
  serviceTaskIds?: string[];
}

export type UpdateEquipmentModelPayload = Partial<CreateEquipmentModelPayload> & {
  isActive?: boolean;
};

export const equipmentModelService = {
  list: (params: {
    page?: number;
    pageSize?: number;
    search?: string;
    manufacturerId?: string;
    equipmentTypeId?: string;
  }): Promise<EquipmentModelListResponse> =>
    apiClient.get<EquipmentModelListResponse>('/equipment-models', { params }).then((r) => r.data),

  get: (id: string): Promise<EquipmentModel> =>
    apiClient.get<EquipmentModel>(`/equipment-models/${id}`).then((r) => r.data),

  create: (payload: CreateEquipmentModelPayload): Promise<EquipmentModel> =>
    apiClient.post<EquipmentModel>('/equipment-models', payload).then((r) => r.data),

  update: (id: string, payload: UpdateEquipmentModelPayload): Promise<EquipmentModel> =>
    apiClient.patch<EquipmentModel>(`/equipment-models/${id}`, payload).then((r) => r.data),

  remove: (id: string): Promise<void> =>
    apiClient.delete(`/equipment-models/${id}`).then(() => undefined),

  uploadImage: (id: string, file: Blob, fileName: string): Promise<EquipmentModel> => {
    const form = new FormData();
    form.append('image', file, fileName);
    return apiClient
      .post<EquipmentModel>(`/equipment-models/${id}/images`, form)
      .then((r) => r.data);
  },

  deleteImage: (id: string, imageIndex: number): Promise<EquipmentModel> =>
    apiClient
      .delete<EquipmentModel>(`/equipment-models/${id}/images/${imageIndex}`)
      .then((r) => r.data),
};
